import dynamic from 'next/dynamic'
import { useTranslation } from '@mc/i18n'
import Nav from '@mc/navigation'
import { paths } from '@mc/paths'
import { MenuLinkGiftingOnMobileNavExp } from '@mc/promos'
import { NavigationEvents, Product } from '@mc/track-event'
import {
  trackNavClick,
  trackPlansClick,
  trackGiftCTAClick,
} from 'components/Navigation/events'
import { businessPath } from 'libs/paths'
import { ConsumerCallout } from './ConsumerCallout'

const Search = dynamic(
  () =>
    import(
      /* webpackChunkName: 'mobile-nav-search' */ 'components/Navigation/shared/Mobile/Search'
    ),
  { ssr: false },
)

export const MobileMenuVariant1 = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <>
      <Search />

      <Nav.MenuLink
        href={paths.checkout}
        onClick={trackPlansClick(NavigationEvents.LEVELS.SECONDARY)}
      >
        <MenuLinkGiftingOnMobileNavExp Control={t('nav.cta.plans')} />
      </Nav.MenuLink>

      <Nav.MenuLink
        href={businessPath()}
        target='_blank'
        rel='noopener noreferrer'
        onClick={trackNavClick(
          'At Work',
          NavigationEvents.LEVELS.SECONDARY,
          undefined,
          Product.MASTERCLASS,
        )}
      >
        {t('nav.cta.work')}
      </Nav.MenuLink>

      <Nav.MenuLink
        href={paths.certificates}
        onClick={trackNavClick(
          'Certificates',
          NavigationEvents.LEVELS.SECONDARY,
          undefined,
          Product.MASTERCLASS,
        )}
      >
        {t('nav.cta.certificates')}
      </Nav.MenuLink>

      <Nav.MenuLink
        href={paths.gift}
        onClick={() => trackGiftCTAClick(NavigationEvents.LEVELS.SECONDARY)}
      >
        {t('nav.cta.gift')}
      </Nav.MenuLink>
      <Nav.MenuLink
        href={paths.helpCenter}
        onClick={trackNavClick('Support', NavigationEvents.LEVELS.SECONDARY)}
      >
        {t('nav.cta.support')}
      </Nav.MenuLink>

      <Nav.MenuLink
        href={paths.logIn()}
        onClick={trackNavClick('Log In', NavigationEvents.LEVELS.SECONDARY)}
      >
        {t('nav.cta.login')}
      </Nav.MenuLink>
      <ConsumerCallout />
    </>
  )
}
